import { render, staticRenderFns } from "./CostItem.vue?vue&type=template&id=79222106&scoped=true"
import script from "./CostItem.vue?vue&type=script&lang=js"
export * from "./CostItem.vue?vue&type=script&lang=js"
import style0 from "./CostItem.vue?vue&type=style&index=0&id=79222106&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79222106",
  null
  
)

export default component.exports